// ---------------------------------------------- modules import
import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";

import { ThemeContext } from "../../contexts/themeContext";

// ---------------------------------------------- the component
const LoggedOut: FunctionComponent = () => (
  <ThemeContext.Consumer>
    {({ theme }) => (
      <li>
        <Link to="/login" style={{ color: theme.syntax }}>
          Login
        </Link>
      </li>
    )}
  </ThemeContext.Consumer>
);

export default LoggedOut;
